import React, { useState, useEffect } from "react";
import { Empty, Divider, Input } from "antd";
import Scrollbar from "react-scrollbars-custom";
import Highlighter from "react-highlight-words";

const PlatemapSample = ({
  selectedSequence,
}) => {
  const [samples, setSamples] = useState([]);
  const [filteredSamples, setFilteredSamples] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [highlighValue, setHighlightValue] = useState("");
  const cards = [
    { label: "Workorder", key: "workorder_id", highlight: false },
    { label: "Assigned To", key: "technician", highlight: false },
    { label: "Genista ID", key: "genista_id", highlight: true },
    { label: "Test", key: "internal_name", highlight: true },
  ];
  useEffect(() => {
    if (selectedSequence) {
      setSamples(selectedSequence.samples_list);
      setFilteredSamples(selectedSequence.samples_list);
      setSearchValue("");
      setHighlightValue("");
    } else {
      setSamples([]);
      setFilteredSamples([]);
      setSearchValue("");
      setHighlightValue("");
    }
  }, [selectedSequence]);

  const onSearch = (value) => {
    setSearchValue(value);
    setHighlightValue(value);
    let filteredList = samples;
    const targetFields = cards.reduce((acc, card) => {
      if (card.highlight) {
        acc.push(card.key);
      }
      return acc;
    }, []);
    const lowerCaseValue = value.toLowerCase();
    filteredList = filteredList.filter((item) => targetFields.find((field) => item[field].toLowerCase().includes(lowerCaseValue)));
    setFilteredSamples(filteredList);
  };

  const handleSearchOnChange = (value) => {
    if (value === "") {
      onSearch("");
    } else {
      setSearchValue(value);
    }
  };

  return (

    <div className="PlatemapSection">
      <div className="PlatemapSection__Header">
        <div className="PlatemapSection__HeaderContent">
          <div className="PlatemapSection__HeaderContent__Info">
            {selectedSequence && (<h5>{`Samples (${samples.length})`}</h5>)}
            {!selectedSequence && (<h5>Samples</h5>)}
          </div>
          <Input.Search
            allowClear
            placeholder="Search by Genista ID, Test"
            className="Platemap__SampleSearch"
            value={searchValue}
            onPressEnter={(e) => onSearch(e.target.value)}
            onSearch={(value) => onSearch(value)}
            onChange={(e) => handleSearchOnChange(e.target.value)}
          />
        </div>
        <Divider className="PlatemapDivider" />
      </div>
      {filteredSamples.length > 0 && (
      <Scrollbar
        className="PlatemapItemScrollBar"
        disableTrackYWidthCompensation
        disableTracksWidthCompensation
      >
        <div className="PlatemapSection__Items__Container">
          {filteredSamples.map((item, index) => (
            <div key={index} className="PlatemapSection__Item PlatemapSection__Item--samples">
              {cards.map((card, cardIdx) => (
                <div key={cardIdx} className="Platemap__TestInfoCard">
                  <label>{`${card.label}:`}</label>
                  <Highlighter
                    highlightClassName="CustomSearchHighlight"
                    autoEscape
                    searchWords={card.highlight ? [highlighValue] : [""]}
                    textToHighlight={item[card.key]}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </Scrollbar>
      )}
      {samples.length === 0 && (<Empty className="PlatemapEmpty" image={Empty.PRESENTED_IMAGE_SIMPLE} />)}
    </div>
  );
};

export default PlatemapSample;
